export default __webpack_public_path__ + "static/media/GregBavington.e91665b6.jpg";